__webpack_require__.p = "https://assets.khanoumi.com/4.139.2.0/_next/";